import type { Participant } from "@vc/models"
import { hasPermission } from "@vc/services/permissions"

/**
 * The headcount beside the Participants panel's title, for an attendee or
 * presenter.
 *
 * A host or co-host reads it on the panel's Participants | Waiting Room bar.
 * That bar is shown to them alone (the Waiting Room is theirs), which left
 * everyone else with no count at all; here it would only repeat it for them, so
 * it renders nothing. Same number as the bar: every row of the list, a
 * screen-share session's included.
 */
export function ParticipantHeadcount({
  participants,
  viewer,
}: {
  participants: Participant[]
  viewer: Participant
}) {
  if (hasPermission(viewer.role, "role-modify")) return null
  return (
    <span className="ml-2 inline-flex h-5 min-w-[22px] items-center justify-center rounded-full bg-sky-100 px-1.5 align-middle text-[11px] font-bold tabular-nums text-sky-700">
      {participants.length}
    </span>
  )
}
